import Container from "../../../../common/Container";
import ContentTextContainerTextOnly from "../../../../common/ContentTextContainer/ContentTextContainerTextOnly";
import TestMemeContainer from "../../../../common/TestMemeContainer";
import EmbedYoutubeLogic from "./../EmbedYoutubeLogic";
import BrowserSourceLogic from "./../BrowserSourceLogic";
import { useNavigate } from "react-router";
import "./tutorial.css";
import { useTranslation } from "react-i18next";

const Tutorial = ({
    profanityFilterExist,
    selectedMemeExists,
    testMemeExists,
    fetchedBrowserSource,
    browserSourceIsActive,
    manualApprovalState,
}) => {
    const { t } = useTranslation("dashboard");

    const navigate = useNavigate();
    let content = <></>;

    // This returns user instructions
    const whatToDoContent = () => {
        let profanitiFilterTextContent = (
            <>
                <span>{t("tutorialProfanitiFilterText")}</span>{" "}
                <img src="/document.svg" alt="#" className="iconSizeMenu" />
                <span>{t("tutorialProfanityFilterDescription")}</span>
            </>
        );

        let selectMemeTextContent = (
            <>
                <span>{t("tutorialSelectedMemeDescription1")}</span>
                <img src="/book-alt.svg" alt="#" className="iconSizeMenu" />
                <span>{t("tutorialSelectedMemeDescription2")}</span>
            </>
        );

        let testMemeTextContent = (
            <>
                <span>
                    {t("testMemeDescription1")} <br />{" "}
                    {t("testMemeDescription2")} <br />{" "}
                    {t("testMemeDescription3")}
                </span>
            </>
        );

        let contentToReturn = <></>;
        let headerTitle = <h2>{t("SetupProgressTitle")}</h2>;

        if (!selectedMemeExists || !testMemeExists) {
            try {
                let testMemeText = (
                    <ContentTextContainerTextOnly
                        title={
                            testMemeExists
                                ? t("tutorialSetupOBSCompleted")
                                : t("tutorialSetupOBS")
                        }
                        text={testMemeTextContent}
                        alignLeft={true}
                        green={testMemeExists}
                        onClick={() => navigate("/dashboard/settings")}
                    />
                );

                let selecteMemeText = (
                    <ContentTextContainerTextOnly
                        title={
                            selectedMemeExists
                                ? t("tutorialSelectedImageCompleted")
                                : t("tutorialSelectedImage")
                        }
                        text={selectMemeTextContent}
                        alignLeft={true}
                        green={selectedMemeExists}
                        onClick={() => navigate("/dashboard/templates")}
                    />
                );

                let profanityFilterText = (
                    <ContentTextContainerTextOnly
                        title={
                            profanityFilterExist
                                ? t("tutorialProfanityFilterSelected")
                                : t("tutorialProfanityFilterSelected")
                        }
                        text={profanitiFilterTextContent}
                        alignLeft={true}
                        green={profanityFilterExist}
                        onClick={() => navigate("/dashboard/filters")}
                    />
                );

                contentToReturn = (
                    <>
                        <Container
                            content={
                                <div className="TutorialContainer">
                                    {headerTitle}
                                    <BrowserSourceLogic
                                        fetchedBrowserSource={
                                            fetchedBrowserSource
                                        }
                                    />
                                    <div className="tutorialContentContainerSetup">
                                        <div className="tutorialTestMemeContainerTest">
                                            <TestMemeContainer
                                                extended={true}
                                            />
                                        </div>
                                        <div className="tutorialContainerContentSide">
                                            {testMemeText}
                                            {selecteMemeText}
                                            {profanityFilterText}
                                        </div>
                                    </div>
                                </div>
                            }
                            isNoBackground={true}
                        />
                        <EmbedYoutubeLogic
                            embedId="0p-uou_ZCts"
                            title={t("youtubeStepByStep")}
                        />
                    </>
                );

                if (selectedMemeExists === null) contentToReturn = <></>;
            } catch (error) {
                console.error(
                    "user set up information was not loaded correctly",
                );
            }
        } else {
            let browserSourceStatusText = (
                <>
                    <div className="tutorialStatusTextOnline">
                        {t("tutorialBrowserSourceIsOnline")}
                        <br />
                        <p className="tutorialStatusUrl">
                            {t("tutorialUrlStatus")}
                        </p>
                    </div>
                </>
            );

            if (!browserSourceIsActive)
                browserSourceStatusText = (
                    <>
                        <div className="tutorialStatusTextOffline">
                            {t("tutorialBrowserSourceIsOffline")}
                            <br />
                            <p
                                className="tutorialStatusUrl"
                                onClick={() =>
                                    (window.location =
                                        "/dashboard/settings/browsersource")
                                }
                            >
                                {t("tutorialStatusUrl")}
                            </p>
                        </div>
                    </>
                );

            let manualApprovalStautsText = manualApprovalState ? (
                <>
                    <div className="tutorialStatusTextOnline">
                        {t("tutorialManaualApprovalIsEnabled")}
                        <br />
                        <p
                            className="tutorialStatusUrl"
                            onClick={() =>
                                (window.location =
                                    "/dashboard/settings/browsersource")
                            }
                        >
                            {t("tutorialStatusManualApproval")}
                        </p>
                    </div>
                </>
            ) : (
                <></>
            );

            contentToReturn = (
                <>
                    <Container
                        content={
                            <div className="TutorialContainer">
                                <h2>{t("tutorialStatusTitle")}</h2>
                                {manualApprovalStautsText}
                                {browserSourceStatusText}
                            </div>
                        }
                        isNoBackground={false}
                    />
                </>
            );
        }

        return contentToReturn;
    };

    content = <>{whatToDoContent()}</>;

    return content;
};

export default Tutorial;
